import { ErrorPageLayout } from '@/components/features/Errors/ErrorPageLayout';
import { Button } from '@/components/ui/shadcn/button';
import { useTranslations } from '@/hooks/useTranslations';
import { Head, Link } from '@inertiajs/react';
import { Home, ShieldAlert } from 'lucide-react';

export default function Forbidden() {
    const { t } = useTranslations();

    return (
        <>
            <Head title={t('errors.forbidden.title', 'Access denied')} />
            <ErrorPageLayout
                icon={<ShieldAlert />}
                tone="danger"
                code={t('errors.forbidden.code', '403')}
                title={t('errors.forbidden.title', 'Access denied')}
                description={t('errors.forbidden.description', "You don't have permission to access this page.")}
                actions={
                    <Button asChild>
                        <Link href="/">
                            <Home className="mr-2 h-4 w-4" />
                            {t('errors.forbidden.back_home', 'Back to home')}
                        </Link>
                    </Button>
                }
            />
        </>
    );
}
